import {Employee, useApiCall} from "@jane/lib/src/api";
import React, {useMemo, useEffect, useState, ReactNode} from "react"
import {JaneEmployee} from "../resources/EmployeeContext";
import {config} from "../config";
import { useToasts } from "@jane/lib/src/toasts/toasts";
import { Select } from "@jane/lib/src/components/form/Select";
import { Button } from "@jane/lib/src/components/form/Button";
import { Card } from "@jane/lib/src/components/Card";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleExclamation} from "@fortawesome/free-solid-svg-icons";

export default function RolesForm(props: {employee: JaneEmployee, enrichedEmployee: Employee&{roles:string[]}, reload: () => void}): ReactNode {
  const currentRole = props.employee.role === "Werknemer" ? "employee" : "coordinator"
  const rolesMap = {
    "employee": "Werknemer",
    "coordinator": "Coordinator",
  }
  const [role, setRole] = useState<"employee"|"coordinator">(currentRole)
  const [additionalRoles, setAdditionalRoles] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const { employees } = useApiCall(config)
  const { showToast } = useToasts()


  // @ts-ignore
  const roles = useMemo(() => {
    return Array.isArray(props.enrichedEmployee.roles) ? props.enrichedEmployee.roles : [];
  }, [props.enrichedEmployee]);
  const filteredRoles = ['telephone', 'hoofdcoordinator', 'learn', 'operationalmanager', 'samenwerken-beheer', 'servicedesk', 'broadcasts', 'social_cards', 'kantoor-medewerker'];
  useEffect(() => {
    setAdditionalRoles(roles.filter((role: string) => filteredRoles.includes(role)));
  }, [roles]);

  function save() {
    setError('')
    setIsLoading(true)
    employees.updateRole(props.employee.sub, role, additionalRoles)
      .then(() => {
        showToast('Wijzigingen opgeslagen', 'Het kan een minuut duren voordat de wijziging is doorgevoerd, herlaad straks de pagina om de wijziging te zien.')
        setRole(role)
        props.reload()
      })
      .catch(err => {
        setError(err)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleCheckboxChange = (roleName: string, isChecked: boolean) => {
    setAdditionalRoles((prevRoles) => {
      if (isChecked) {
        return [...prevRoles, roleName];
      } else {
        return prevRoles.filter((role) => role !== roleName);
      }
    });
  };

  return <Card title={'Rol aanpassen'} id={"role"}>
    <div className={"space-y-4"}>
      <Select options={rolesMap} value={role} onChange={(e) => setRole(e as "employee" | "coordinator")}
              label={'Role'}/>

      <>
        <h1 className={"pt-3 font-bold"}>Extra rollen</h1>
        <div className={'grid grid-cols-1 lg:grid-cols-2 gap-4'}>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('hoofdcoordinator') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('hoofdcoordinator', e.target.checked)} checked={additionalRoles.includes('hoofdcoordinator')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Hoofdcoordinator</h1>
              <p className={'text-sm'}>Gelijke rechten aan een reguliere coördinator, maar dan met toegang tot alle teams.</p>
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('operationalmanager') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('operationalmanager', e.target.checked)} checked={additionalRoles.includes('operationalmanager')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Operational Manager</h1>
              <p className={'text-sm'}>Gelijke rechten aan een reguliere coördinator, maar kan taken zien van alle teams.</p>
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('learn') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('learn', e.target.checked)} checked={additionalRoles.includes('learn')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Learn</h1>
              <p className={'text-sm'}>Kan de inhoud en voortgang beheren van de <strong>Samen Wijzer</strong> kennisbank.</p>
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('telephone') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('telephone', e.target.checked)} checked={additionalRoles.includes('telephone')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Telefonie</h1>
              <p className={'text-sm'}>Heeft toegang tot de telefoontab van de web omgeving.</p>
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('samenwerken-beheer') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('samenwerken-beheer', e.target.checked)} checked={additionalRoles.includes('samenwerken-beheer')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>SamenWerken Beheer</h1>
              <p className={'text-sm'}>Kan samenwerken instellingen en sjablonen beheren.</p>
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('servicedesk') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('servicedesk', e.target.checked)} checked={additionalRoles.includes('servicedesk')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Servicedesk</h1>
              <p className={'text-sm'}>Heeft toegang tot het resetten van wachtwoorden & 2FA.</p>
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${(role === 'coordinator' || additionalRoles.includes('kantoor-medewerker')) ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('kantoor-medewerker', e.target.checked)} checked={(additionalRoles.includes('kantoor-medewerker') || role === 'coordinator')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Kantoormedewerker</h1>
              <p className={'text-sm'}>Heeft toegang tot o.a. SamenWerken</p>
              {role === 'coordinator' && <div className={'flex items-center text-sm'}>
                <FontAwesomeIcon icon={faCircleExclamation} className={'mr-1'} />
                <div>Deze rol is impliciet vanuit coordinator</div>
              </div>}
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('broadcasts') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('broadcasts', e.target.checked)} checked={additionalRoles.includes('broadcasts')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Publicaties</h1>
              <p className={'text-sm'}>Heeft toegang tot het beheren en versturen van publicaties.</p>
            </div>
          </label>
          <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${additionalRoles.includes('social_cards') ? 'bg-brand-on-primary-container/5' : ''} rounded-lg p-2`}>
            <input className={'mx-2'} type="checkbox" onChange={(e) => handleCheckboxChange('social_cards', e.target.checked)} checked={additionalRoles.includes('social_cards')}/>
            <div className={''}>
              <h1 className={'font-medium mb-1'}>Sociale kaarten</h1>
              <p className={'text-sm'}>Heeft toegang tot het beheren van sociale kaarten.</p>
            </div>
          </label>
        </div>
      </>

      <Button type={'primary'} size={'sm'} disabled={isLoading} text={'Opslaan'} onClick={save}/>
      {error === "" ? "" : <>
        <div className={"text-danger mt-2"}>{error}</div>
      </>}
    </div>
  </Card>
}
